import React, { ReactNode } from "react";
import {
  Card,
  FormControl,
  ToggleButtonGroup,
  ToggleButton,
  Grid,
  List,
  TextField,
  Toolbar,
  useTheme,
  useMediaQuery,
  Paper,
} from "@mui/material";
import {
  mobileCardSx,
  toolbarSx,
  toolbarSearchSx,
  AUTURA_ASPHALT_LIGHT,
  MOBILE_LAYOUT,
} from "utils";
import { useTranslation } from "react-i18next";
import ViolationListItemSkeleton from "./ViolationListItem";

interface MobileViolationsSkeletonProps {
  allowCreate: boolean;
}

const MobileViolationsSkeleton = ({
  allowCreate,
}: MobileViolationsSkeletonProps): ReactNode => {
  const { t } = useTranslation();
  const { palette, breakpoints } = useTheme();
  const isPhone = useMediaQuery(breakpoints.down("sm"));

  return (
    <Card raised sx={{ ...mobileCardSx, mb: 16, mx: -1, borderRadius: 0 }}>
      <List aria-label={t("violation.activeListHeader")}>
        {Array.from({ length: 15 }).map((_, index) => (
          <ViolationListItemSkeleton
            key={index}
            active={true}
            sx={{ px: { xs: 2, sm: 4 } }}
          />
        ))}
      </List>
      <Paper
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: MOBILE_LAYOUT.footerHeight,
          display: "flex",
          flexDirection: "column",
          zIndex: 1000,
          borderTop: "1px solid",
          borderColor: "primary.main",
          borderRadius: 0,
          backgroundColor: "secondary.main",
        }}
        elevation={3}
      >
        <Toolbar
          sx={{
            ...toolbarSx,
            backgroundColor: AUTURA_ASPHALT_LIGHT,
            width: "100%",
          }}
        >
          <Grid container width={"100%"} spacing={2}>
            <Grid size={12}>
              <FormControl sx={{ width: "100%" }}>
                <ToggleButtonGroup
                  aria-labelledby="violations-view-select"
                  value={"active"}
                  exclusive
                  size={isPhone ? "small" : "medium"}
                  color={"primary"}
                  sx={{
                    ...toolbarSearchSx,
                    borderColor: palette.secondary.main,
                  }}
                  fullWidth
                >
                  <ToggleButton value="active" key={"active"}>
                    {t("active")}
                  </ToggleButton>
                  <ToggleButton
                    value="inactive"
                    key="inactive"
                  >{`Inactive`}</ToggleButton>
                  {allowCreate && (
                    <ToggleButton value="create" key="create">
                      {t("create")}
                    </ToggleButton>
                  )}
                </ToggleButtonGroup>
              </FormControl>
            </Grid>
            <Grid size={12}>
              <TextField
                fullWidth
                placeholder={t("violation.activeSearchPlaceholder")}
                variant="outlined"
                disabled
                size={isPhone ? "small" : "medium"}
                sx={{ ...toolbarSearchSx, borderColor: palette.secondary.main }}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </Paper>
    </Card>
  );
};

export default MobileViolationsSkeleton;
